// Re-export individual classes for pattern: import { TestCaseRun } from "@stanterprise/protobuf/testsystem/v1/entities"
import { testsystem as testCaseNS } from '../../../lib/testsystem/v1/entities/test_case';
import { testsystem as testSuiteNS } from '../../../lib/testsystem/v1/entities/test_suite';

// Export individual classes from test_case
export type TestCaseRun = testCaseNS.v1.entities.TestCaseRun;
export const TestCaseRun = testCaseNS.v1.entities.TestCaseRun;

export type StepRun = testCaseNS.v1.entities.StepRun;
export const StepRun = testCaseNS.v1.entities.StepRun;

// Export individual classes from test_suite
export type TestSuiteRun = testSuiteNS.v1.entities.TestSuiteRun;
export const TestSuiteRun = testSuiteNS.v1.entities.TestSuiteRun;

export type SuiteType = testSuiteNS.v1.entities.SuiteType;
export const SuiteType = testSuiteNS.v1.entities.SuiteType;
